import { signal } from '@preact/signals-react';
import type { UserDto } from '@/api-gen/api.schemas';

export const currentUser = signal<UserDto | null>(null);
